export default __webpack_public_path__ + "static/media/c3.efa3d02c.jpeg";